import { Controller } from "@hotwired/stimulus"
import * as echarts from "echarts"

const INITIAL_WINDOW_POINTS = 100

export default class extends Controller {
  static targets = ["canvas"]
  static values = { data: Object, title: String }

  connect() {
    this.chart = echarts.init(this.canvasTarget)
    this.resizeHandler = () => this.chart.resize()
    window.addEventListener("resize", this.resizeHandler)
    this.render()
  }

  render() {
    const total = this.dataValue.labels.length
    const start = total > INITIAL_WINDOW_POINTS ? 100 - (INITIAL_WINDOW_POINTS / total) * 100 : 0

    this.chart.setOption({
      ...(this.titleValue ? { title: { text: this.titleValue, backgroundColor: 'white', textStyle: { color: 'black' } } } : {}),
      xAxis: {
        type: "category",
        data: this.dataValue.labels
      },
      yAxis: {
        type: "value"
      },
      tooltip: {
        trigger: "axis"
      },
      legend: {
        bottom: 0,
        type: "scroll"
      },
      toolbox: {
        feature: {
          saveAsImage: {
            name: this.titleValue || "area-chart"
          }
        }
      },
      grid: {
        top: this.titleValue ? 56 : 40,
        left: 8,
        right: 8,
        bottom: 80,
        containLabel: true
      },
      dataZoom: [
        { type: "inside", start, end: 100 },
        { type: "slider", start, end: 100, bottom: 36 }
      ],
      series: this.dataValue.series
    })
  }

  disconnect() {
    window.removeEventListener("resize", this.resizeHandler)

    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
  }
}
